// extracted by mini-css-extract-plugin
export default {"description":"Y4QYT5DyPczkYUcGWda5rg=="};